<script>
    import { onMount } from "svelte";
    import { ModalBody, ModalFooter, ModalHeader, Modal } from "sveltestrap";
    import backend from "../../../../../server";
    
    export let isCancel = false; 
  
    let filter = {limit: 100, startId: 0,siteCode: 'latinsport21' };
    let isLoading = false; 
    let bonuses = [];
    let selectedIds = [];
    let bonusCandel = {  reason: '',   force: true, ids: selectedIds }
  
    const closeModal = () => {
      isCancel = false;  
    };
  
    onMount(async () => {
      await getPlayesByCampaing(filter);
    });
  
    const getPlayesByCampaing = async(filter) => {
      try {
        isLoading = true;
        let response = await backend.freespin.listFreeSpinsPP(filter);
        bonuses = response.data.result.bonuses;
      } catch (error) {
        console.log(error.message);
      }
      isLoading = false;
    }
  
    const handleRowClick = (id) => {
      if (selectedIds.includes(id)) 
        selectedIds = selectedIds.filter(selectedId => selectedId !== id);
       else selectedIds = [...selectedIds, id];
      
    }
  
const saveGames = async () => {
  bonusCandel.ids = [...selectedIds];

  if (!bonusCandel.reason) return;

  isLoading = true; 
  console.log(bonusCandel);

  try {
    let response = await backend.freespin.saveBonusCancelation(bonusCandel);
    console.log("Respuesta del servidor:", response);
    closeModal(); // Cierra el modal al guardar
  } catch (error) {

    alert("Hubo un error al intentar guardar los cambios.");
  } finally {
    isLoading = false; // Si isLoading es un estado, usa setIsLoading(false)
  }
}

  </script>
  
  <Modal isOpen={isCancel} toggle={closeModal} size="lg">
    <ModalHeader toggle={closeModal}>
      Cancelar rondas gratuitas. 
    </ModalHeader>
    <ModalBody>
        <div class="credentials-section">

        <div class="table-container">
        <table size="sm" class="table  table-sm">
        <thead class="table-dark">
          <tr>
            <th>N°</th>
            <th>Rondas id</th>
            <th>Jugador</th>
            <th style="text-align: center;">Seleccionado</th>
          </tr>
        </thead>
        <tbody>
          {#if isLoading}
            <tr><td colspan="5" style="text-align: center;">Cargando...</td></tr>
          {:else if bonuses.length === 0}
            <tr><td colspan="5" style="text-align: center;">No se encontró</td></tr>
          {:else}
          {#each bonuses as bonus, index}
              <tr 
                on:click={() => handleRowClick(bonus.bonusId)} 
                class:selected={selectedIds.includes(bonus.bonusId)}
                style="cursor: pointer;">
                <td>{index + 1}</td>
                <td>{bonus.bonusId}</td>
                <td>{bonus.playerId}</td>
                <td style="text-align: center;">
                  <span>{selectedIds.includes(bonus.bonusId) ? '✔️' : ''}</span>
                </td>
              </tr>
            {/each}
          {/if}
        </tbody>
      </table>
      </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label for="reason">Razón</label>
          <textarea  class="form-control"  type="text"  rows="1" 
            bind:value={bonusCandel.reason} 
            placeholder="Razón"
          />
        </div>
        <div class="col-md-6">
          <label for="force">Forzar</label>
          <select    class="form-control"  bind:value={bonusCandel.force}   >
            <option value={true}>Forzar</option>
            <option value={false}>No Forzar</option>
          </select>
        </div>
      </div>
      
    </ModalBody>
    <ModalFooter>
      <button class="btn btn-primary" on:click={saveGames} disabled={isLoading}>
        {#if isLoading}
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Cargando...
        {:else}
          Guardar
        {/if}
      </button>
    </ModalFooter>
  </Modal>
  <style>
     .credentials-section {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .table-container {
    max-height: 300px;
    overflow-y: auto;
  }
  .selected {
    background-color: #dfefef; /* Color de fondo para la fila seleccionada */
  }
 
  </style>